export const responseFormatViews = ['text', 'rich'] as const;
export type ResponseFormatView = (typeof responseFormatViews)[number];
